import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 12px 0 20px 0;
  position: relative;
  z-index: 1;

  .row {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    margin: 0;
    column-gap: 16px;
    row-gap: 12px;
  }

  .inventory-policy-box {
    min-width: 0;
  }

  @media (min-width: 768px) {
    .row {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  @media (min-width: 1440px) {
    .row {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
  }
`;

export const Box = styled.div`
  background: #ffffff;
  border: 1px solid #e0e4e8;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: visible;
  height: 100%;
  width: 100%;

  .box-label {
    font-style: normal;
    font-weight: var(--font-weight-semibold);
    font-size: 11px;
    line-height: 14px;
    color: #6b7280;
    margin-bottom: 6px;
    display: block;
  }

  .box-value {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    display: block;
  }

  .box-doi {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #6b7280;
    margin-top: 4px;
    display: block;
  }

  &.current-stock .box-value {
    color: #2F4296;
  }

  &.target-policy .box-value {
    color: #1F8E4D;
  }

  &.minimum-stock .box-value {
    color: #E5392B;
  }

  &.maximum-stock .box-value {
    color: #F5A623;
  }

  &.policy-status .box-value {
    &.status-on-target {
      color: #1F8E4D;
    }
    &.status-below-target {
      color: #E5392B;
    }
    &.status-above-target {
      color: #F5A623;
    }
  }
`;
